export interface TsAppVersion {
    version: string;
    name: string;
    description?: string;
    versionLong?: string;
    versionDate: string;
    gitCommitHash?: string;
    gitCommitDate?: string;
    gitTag?: string;
};

export const versions: TsAppVersion = {
    version: '2.8.2',
    name: 'fpar',
    versionDate: '2026-09-28T17:20:43.457Z',
};
export default versions;
